import React from 'react';
import { FileTextIcon } from 'lucide-react';
interface DocPreviewProps {
  name: string;
  ownerName: string;
  regNo: string;
  fileName?: string;
  fileType?: 'image' | 'pdf';
  large?: boolean;
}

/** Renders a simulated scanned document so previews look realistic without real files. */
export function DocPreview({
  name,
  ownerName,
  regNo,
  fileName,
  fileType = 'image',
  large = false
}: DocPreviewProps) {
  if (!fileName) {
    return <div className={`flex flex-col items-center justify-center rounded-lg border border-dashed border-line bg-canvas text-ink-soft ${large ? 'h-[420px]' : 'h-24'}`} data-id="element-742" data-mp="xvnvojxwus5c">
        <FileTextIcon className="h-6 w-6" data-id="element-743" data-mp="o5mbi38ohtvp" />
        <span className="text-xs mt-1" data-id="element-744" data-mp="o4b65yzl4e2h">ফাইল জমা হয়নি</span>
      </div>;
  }
  return <div className={`relative rounded-lg border border-line bg-[#FBFAF6] overflow-hidden ${large ? 'h-[420px] p-6' : 'h-24 p-2'}`} data-id="element-745" data-mp="j5gqh5wwz5ml">
      <div className={`flex items-center gap-2 border-b border-[#C9C2AE] ${large ? 'pb-3 mb-4' : 'pb-1 mb-1.5'}`} data-id="element-746" data-mp="1bwi7zdo2xd9a">
        <div className={`rounded-full border border-[#8C8467] ${large ? 'h-9 w-9' : 'h-3 w-3'}`} data-id="element-747" data-mp="2m177j5rqmvg5" />
        <div data-id="element-748" data-mp="2q3akxzxywa42">
          <p className={`font-bold text-[#3F3A2C] ${large ? 'text-base' : 'text-[8px] leading-none'}`} data-id="element-749" data-mp="2q1r2c2ou9mz4">{name}</p>
          {large && <p className="text-xs text-[#6B654F]" data-id="element-750" data-mp="2cbdwc5vicicf">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার — নমুনা কপি</p>}
        </div>
      </div>
      {large ? <div className="grid grid-cols-[1fr_96px] gap-6" data-id="element-751" data-mp="22dq01bi972s5">
          <div className="space-y-3 text-sm text-[#3F3A2C]" data-id="element-752" data-mp="22c53jgcdp9rn">
            <p data-id="element-753" data-mp="27ct4ouubn6zl"><span className="text-[#6B654F]" data-id="element-754" data-mp="27ct2qpargwwy">নাম:</span> {ownerName}</p>
            <p data-id="element-755" data-mp="1td1k2b9auscm"><span className="text-[#6B654F]" data-id="element-756" data-mp="1td1m0gsv12f9">যানবাহন:</span> {regNo}</p>
            {Array.from({
          length: 6
        }).map((_, i) => <div key={i} className="h-2 rounded bg-[#E3DDCB]" style={{
          width: `${90 - i * 9}%`
        }} data-id="element-757" data-mp="1ycw9sbhc9bw3" data-mpi={i} />)}
          </div>
          <div className="h-28 rounded border border-[#C9C2AE] bg-[#EDE8D8]" data-id="element-758" data-mp="3nrkl09e70nsj" />
        </div> : <div className="space-y-1" data-id="element-759" data-mp="3snt94cadbrbu">
          {[80, 64, 72, 50].map(w => <div key={w} className="h-1 rounded bg-[#E3DDCB]" style={{
        width: `${w}%`
      }} data-id="element-760" data-mp="3qcacqef51wv1" />)}
        </div>}
      <span className={`absolute rounded border-2 border-danger/50 text-danger/60 font-bold rotate-[-12deg] ${large ? 'bottom-8 right-8 px-3 py-1 text-sm' : 'bottom-1.5 right-1.5 px-1 text-[7px]'}`} data-id="element-761" data-mp="3m82i60m01mow">নমুনা</span>
      <span className={`absolute left-2 bottom-1.5 font-mono text-ink-soft ${large ? 'text-xs' : 'text-[8px]'}`} data-id="element-762" data-mp="3cdalr045l5vp">
        {fileType === 'pdf' ? 'PDF' : 'IMG'} · {fileName}
      </span>
    </div>;
}